/**
 * Character class for the id inside a GFM-style citation marker (`[^<id>]`).
 *
 * This must stay in sync with the agents service, which generates the ids and
 * allows hyphens (`CITATION_ID_RE` in `fountain_agents/lib/citations`). Survey
 * citations embed a primary-survey UUID, e.g.
 * `[^qr_47880543-7909-40b9-a99e-421ea1511393]`, so excluding `-` here leaves
 * those markers unparsed and they surface as raw text in the report.
 */
export const CITATION_ID_PATTERN = '[A-Za-z0-9_-]+';
